import classNames from 'classnames';

interface IProps {
  name: string;
  checked?: boolean;
}

const PackageListItem = ({ name, checked }: IProps) => {
  return (
    <div
      className={classNames(
        'w-full text-start px-3 py-1 rounded-md font-[Manrope] text-[16px] text-[#303030] focus:outline-none',
        { 'bg-[#1b43321f]': checked },
      )}
    >
      {name}
    </div>
  );
};

export default PackageListItem;
